import { render, staticRenderFns } from "./plaintes.html?vue&type=template&id=9a48fc0a&scoped=true&external"
import script from "./plaintes.js?vue&type=script&lang=js&external"
export * from "./plaintes.js?vue&type=script&lang=js&external"
import style0 from "./plaintes.scss?vue&type=style&index=0&id=9a48fc0a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a48fc0a",
  null
  
)

export default component.exports